"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RosettaNetworkOptionsResponseAllowToJSON = exports.RosettaNetworkOptionsResponseAllowFromJSONTyped = exports.RosettaNetworkOptionsResponseAllowFromJSON = void 0;
const _1 = require("./");
function RosettaNetworkOptionsResponseAllowFromJSON(json) {
    return RosettaNetworkOptionsResponseAllowFromJSONTyped(json, false);
}
exports.RosettaNetworkOptionsResponseAllowFromJSON = RosettaNetworkOptionsResponseAllowFromJSON;
function RosettaNetworkOptionsResponseAllowFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'operation_statuses': (json['operation_statuses'].map(_1.RosettaOperationStatusFromJSON)),
        'operation_types': json['operation_types'],
        'errors': (json['errors'].map(_1.RosettaErrorNoDetailsFromJSON)),
        'historical_balance_lookup': json['historical_balance_lookup'],
    };
}
exports.RosettaNetworkOptionsResponseAllowFromJSONTyped = RosettaNetworkOptionsResponseAllowFromJSONTyped;
function RosettaNetworkOptionsResponseAllowToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'operation_statuses': (value.operation_statuses.map(_1.RosettaOperationStatusToJSON)),
        'operation_types': value.operation_types,
        'errors': (value.errors.map(_1.RosettaErrorNoDetailsToJSON)),
        'historical_balance_lookup': value.historical_balance_lookup,
    };
}
exports.RosettaNetworkOptionsResponseAllowToJSON = RosettaNetworkOptionsResponseAllowToJSON;
//# sourceMappingURL=RosettaNetworkOptionsResponseAllow.js.map